import { Component } from 'react';
import { assoc } from 'ramda';
import { ImageUploader } from '../../components';
import s from './HostStyles.module.scss';

export default class ImageUploaderHost extends Component {
    constructor(props) {
        super(props);
        this.state = { imageList: [] };
    }

    updateListProp = (imageListType, updatedFile, updatedProp, updatedValue) => {
        const { imageList } = this.state;
        this.setState({
            imageList: imageList.map(f => {
                if (f.caption === updatedFile.caption && f.dateUploaded === updatedFile.dateUploaded) {
                    f = assoc(updatedProp, updatedValue, f);
                }
                return f;
            }),
        });
    };

    updateListOrder = (imageListType, reorderedArray) => {
        this.setState({ imageList: reorderedArray });
    };

    addToList = (imageListType, additionalItems) => {
        const { imageList } = this.state;

        this.setState({ imageList: imageList.concat(additionalItems) });
    };

    removeFromList = (imageListType, itemToRemove) => {
        const { imageList } = this.state;
        this.setState({ imageList: imageList.filter(f => f.caption !== itemToRemove.caption || f.dateUploaded !== itemToRemove.dateUploaded) });
    };

    openImageInNewTab = async (base64URL, image) => {
        if (base64URL) {
            const win = window.open();
            win.document.write(`<image src="${base64URL}" allowfullscreen />`);
            window.stop();
        } else {
            window.open(`https://img.locuslabs.com/poi/${image.blobId}`);
        }
    };

    render() {
        const { imageList } = this.state;

        return (
            <div className={s.editor} style={{ padding: '100px' }}>
                <ImageUploader
                    type="secondary"
                    imageList={imageList}
                    onPropChange={this.updateListProp}
                    onListOrderChange={this.updateListOrder}
                    onItemAdditions={this.addToList}
                    onItemRemoval={this.removeFromList}
                    openImageInNewTab={this.openImageInNewTab}
                />
            </div>
        );
    }
}
